<div class="inner">
  <div class="top">
    <button
      app-burger
      [close]="close"
      title="{{ Translations.Close | translate }}"></button>
    <a class="logo" routerLink="/">
      <img
        src="assets/images/logo.svg"
        alt="{{ Translations.MenuAlt | translate }}" />
    </a>
  </div>
  <ul>
    <li>
      <a
        class="menu-item"
        [routerLink]="routes.home | route"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }">
        <app-icon src="assets/images/icons/home.svg"></app-icon>
        <span>{{ Translations.MenuHome | translate }}</span>
      </a>
    </li>
    <li>
      <a
        class="menu-item"
        [routerLink]="routes.companies | route"
        routerLinkActive="active">
        <app-icon src="assets/images/icons/companies.svg"></app-icon>
        <span>{{ Translations.MenuCompanies | translate }}</span>
      </a>
      <ul
        [appSlideToggle]="current === sections.companies"
        [appSlideToggleTiming]="noAnimation ? 0 : 300"
        appUiTour="sub-menu">
        <li>
          <a
            [routerLink]="routes.companiesSector | route"
            routerLinkActive="active"
            >{{ Translations.MenuSector | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="routes.companiesActivity | route"
            routerLinkActive="active"
            >{{ Translations.MenuActivity | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="routes.companiesSize | route"
            routerLinkActive="active"
            >{{ Translations.MenuCompanySize | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="routes.companiesLocation | route"
            routerLinkActive="active"
            >{{ Translations.MenuLocation | translate }}</a
          >
        </li>
      </ul>
    </li>
    <li>
      <a
        class="menu-item"
        [routerLink]="routes.employees | route"
        routerLinkActive="active">
        <app-icon src="assets/images/icons/employees.svg"></app-icon>
        <span>{{ Translations.MenuEmployees | translate }}</span>
      </a>
      <ul
        [appSlideToggle]="current === sections.employees"
        [appSlideToggleTiming]="noAnimation ? 0 : 300">
        <li>
          <a
            [routerLink]="routes.employeesActivity | route"
            routerLinkActive="active"
            >{{ Translations.MenuActivity | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="routes.employeesGender | route"
            routerLinkActive="active"
            >{{ Translations.MenuSex | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="routes.employeesEvolutionWomen | route"
            routerLinkActive="active"
            >{{ Translations.MenuWomen | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="routes.employeesAge | route"
            routerLinkActive="active"
            >{{ Translations.MenuAge | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="routes.employeesLocation | route"
            routerLinkActive="active"
            >{{ Translations.MenuLocation | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="routes.employeesJob | route"
            routerLinkActive="active"
            >{{ Translations.MenuJob | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="routes.employeesJobEvolution | route"
            routerLinkActive="active"
            >{{ Translations.MenuJobEvolution | translate }}</a
          >
        </li>
      </ul>
    </li>
    <li>
      <a
        class="menu-item"
        [routerLink]="routes.interns | route"
        routerLinkActive="active">
        <app-icon src="assets/images/icons/interns.svg"></app-icon>
        <span>{{ Translations.MenuInternship | translate }}</span>
      </a>
      <ul
        [appSlideToggle]="current === sections.interns"
        [appSlideToggleTiming]="noAnimation ? 0 : 300">
        <li>
          <a
            routerLinkActive="active"
            [routerLink]="routes.internsEvolution | route"
            >{{ Translations.MenuEvolution | translate }}</a
          >
        </li>
        <li>
          <a
            routerLinkActive="active"
            [routerLink]="routes.internsCategory | route"
            >{{ Translations.MenuTheme | translate }}</a
          >
        </li>
      </ul>
    </li>
    <li>
      <a
        class="menu-item"
        [routerLink]="routes.selfEmployed | route"
        routerLinkActive="active">
        <app-icon src="assets/images/icons/self-employed.svg"></app-icon>
        <span>{{ Translations.MenuSelfEmployed | translate }}</span>
      </a>
      <ul
        [appSlideToggle]="current === sections.selfEmployed"
        [appSlideToggleTiming]="noAnimation ? 0 : 300">
        <li>
          <a
            routerLinkActive="active"
            [routerLink]="routes.selfEmployedCategory | route"
            >{{ Translations.MenuTheme | translate }}</a
          >
        </li>
        <li>
          <a
            routerLinkActive="active"
            [routerLink]="routes.selfEmployedKeyFigures | route"
            >{{ Translations.MenuKeyFigures | translate }}</a
          >
        </li>
      </ul>
    </li>
    <li>
      <a
        class="menu-item"
        [routerLink]="routes.professionals | route"
        routerLinkActive="active">
        <app-icon src="assets/images/icons/work-studies.svg"></app-icon>
        <span>{{ Translations.MenuWorkStudy | translate }}</span>
      </a>
      <ul
        [appSlideToggle]="current === sections.workStudy"
        [appSlideToggleTiming]="noAnimation ? 0 : 300">
        <li>
          <span class="submenu">{{
            Translations.MenuApprenticeship | translate
          }}</span>
          <ul>
            <li>
              <a
                [routerLink]="routes.apprenticesEvolution | route"
                routerLinkActive="active"
                >{{ Translations.MenuEvolution | translate }}</a
              >
            </li>
            <li>
              <a
                [routerLink]="routes.apprenticesDegree | route"
                routerLinkActive="active"
                >{{ Translations.MenuDegree | translate }}</a
              >
            </li>
            <li>
              <a
                [routerLink]="routes.apprenticesSector | route"
                routerLinkActive="active"
                >{{ Translations.MenuDomain | translate }}</a
              >
            </li>
            <li>
              <a
                [routerLink]="routes.apprenticesActivity | route"
                routerLinkActive="active"
                >{{ Translations.MenuActivity | translate }}</a
              >
            </li>
            <li>
              <a
                [routerLink]="routes.apprenticesAge | route"
                routerLinkActive="active"
                >{{ Translations.MenuAge | translate }}</a
              >
            </li>
          </ul>
        </li>
        <li>
          <span class="submenu">{{ Translations.MenuPro | translate }}</span>
          <ul>
            <li>
              <a
                [routerLink]="routes.professionalsEvolution | route"
                routerLinkActive="active"
                >{{ Translations.MenuEvolution | translate }}</a
              >
            </li>
            <li>
              <a
                [routerLink]="routes.professionalsSector | route"
                routerLinkActive="active"
                >{{ Translations.MenuDomain | translate }}</a
              >
            </li>
            <li>
              <a
                [routerLink]="routes.professionalsActivity | route"
                routerLinkActive="active"
                >{{ Translations.MenuActivity | translate }}</a
              >
            </li>
            <li>
              <a
                [routerLink]="routes.professionalsAge | route"
                routerLinkActive="active"
                >{{ Translations.MenuAge | translate }}</a
              >
            </li>
          </ul>
        </li>
      </ul>
    </li>
    <li>
      <a
        class="menu-item"
        [routerLink]="routes.students | route"
        routerLinkActive="active">
        <app-icon src="assets/images/icons/students.svg"></app-icon>
        <span>{{ Translations.MenuStudent | translate }}</span>
      </a>
      <ul
        [appSlideToggle]="current === sections.students"
        [appSlideToggleTiming]="noAnimation ? 0 : 300">
        <li>
          <a routerLinkActive="active" [routerLink]="routes.students | route">{{
            Translations.MenuSpecialization | translate
          }}</a>
        </li>
      </ul>
    </li>
  </ul>
</div>
